<script setup lang="ts">
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { VerificationStep } from '../../AccountPanelVerificationSteps.vue'

import ReferralCode from './ReferralCode.vue'
import { GiftIcon, PlusIcon } from '@heroicons/vue/outline'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { ref } from 'vue'
import { notify } from '../../../../utilities/useNotifications'
import { i18n } from '../../../../localization'

const state = usePersonalAccountDataState()
state.fetchReferralCodes()

const loading = ref(false)

async function generateNewReferralCode() {
    loading.value = true
    try {
        await state.generateNewReferralCode()
    } catch (e) {
        notify('Error', i18n.global.t('error'), e.response?.data?.message || i18n.global.t('errors.general_error'))
    }
    loading.value = false
}
</script>

<template>
    <div class="mb-10 px-4">
        <div v-if="state.referralCodes.length === 0" class="py-4 text-center">
            <div class="my-3 flex justify-center">
                <GiftIcon class="w-12 text-gray-300" />
            </div>
            <div class="flex-initial md:flex-1">
                <h2 class="text-sm font-bold">{{ $t('referral_program.generate_referral_code') }}</h2>
                <p class="pt-1 text-xs leading-tight">
                    {{ $t('referral_program.generate_referral_code_description') }}
                </p>
            </div>

            <BaseButtonMuted
                size="lg"
                :icon="PlusIcon"
                class="mt-4"
                :loading="loading"
                @click="generateNewReferralCode">
                {{ $t('referral_program.generate_referral_code') }}
            </BaseButtonMuted>
        </div>
        <ReferralCode
            v-for="(code, idx) in state.referralCodes"
            v-else
            :key="idx"
            :referral-code="code"
            class="mt-10" />
    </div>
</template>
